export function formatNumber(value) {
  return (Math.floor(value * 100) / 100).toString();
}

export function formatDuration(seconds, locale = 'zh') {
  let s = parseInt(seconds);
  let m = 0;
  let h = 0;
  if (s >= 60) {
    m = parseInt(s / 60);
    s = parseInt(s % 60);
    if (m >= 60) {
      h = parseInt(m / 60);
      m = parseInt(m % 60);
    }
  }
  const units = locale === 'en'
    ? { second: 's', minute: 'm', hour: 'h' }
    : { second: '秒', minute: '分', hour: '小时' };
  let text = `${s} ${units.second}`;
  if (m > 0) text = `${m} ${units.minute} ${text}`;
  if (h > 0) text = `${h} ${units.hour} ${text}`;
  return text;
}
